const featureNameKeys = {
  curate: 'curate',
  request: 'request',
};

export default featureNameKeys;
